<template>
  <!--  -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <yq-date-range v-model:start-time="searchInfo.startAttendanceTime" v-model:end-time="searchInfo.endAttendanceTime" class="double-width">
            <template #prefix>巡检时间</template>
          </yq-date-range>
          <el-select v-model="searchInfo.projectId" clearable filterable>
            <template #prefix>项目名称</template>
            <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.id"/>
          </el-select>
          <el-select v-model="searchInfo.siteId" clearable filterable>
            <template #prefix>工地名称</template>
            <el-option v-for="item in siteList" :key="item.id" :label="item.siteName" :value="item.id"/>
          </el-select>
          <el-select v-model="searchInfo.classmateId" clearable filterable>
            <template #prefix>班组名称</template>
            <el-option v-for="item in classmateList" :key="item.id" :label="item.classmateName" :value="item.id"/>
          </el-select>
          <employee-select v-model="searchInfo.employeeId">
            <template #prefix>巡检人员</template>
          </employee-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border >
          <yq-table-column  label="计划名称" prop="templateName" min-width="180rem"/>
          <yq-table-column label="项目名称" prop="projectName" />
          <yq-table-column label="工地名称" prop="siteName" />
          <yq-table-column label="班组名称" prop="classmateName" />
          <yq-table-column label="巡检人员" prop="userName"/>
          <yq-table-column label="巡检时间" prop="taskTime"/>
          <yq-table-column label="巡检结果" prop="checkResult">
            <template v-slot="{row}">
              <el-tag type="success" v-if="row.checkResult === 0">正常</el-tag>
              <el-tag type="danger" v-else-if="row.checkResult === -1">异常</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="提交时间" prop="taskTimeExecute"/>
          <yq-table-column  label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button @click="router.push(`/checkWarranty/plan/record/detail?id=${row.id}`)">查看</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition";
import FormPage from "@/components/h5/layout/FormPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage";
import TableButton from "@/components/h5/button/TableButton";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import YqDateRange from "@/components/h5/date/YqDateRange.vue";
import {useRoute, useRouter} from "vue-router";
import safetyTaskRecordApi from "@/api/dz-luqiao/safetyTaskRecordsApi";
import luqiaoCommonApi from "@/api/dz-luqiao/luqiaoCommonApi";
import Util from "@/util/util";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    EmployeeSelect,
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage, YqDateRange
  },
  data() {
    return {
      searchInfo: {
        taskStatus: 1,
        startAttendanceTime: "",
        endAttendanceTime: "",
      },
      dataList: [],
      projectList: [],
      classmateList: [],
      siteList: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.resetSearch();
    luqiaoCommonApi.queryProjectNoPage().then(list => this.projectList = list);
    luqiaoCommonApi.queryClassmateNoPage().then(list => this.classmateList = list);
    luqiaoCommonApi.querySiteNoPage().then(list => this.siteList = list);
  },
  methods: {
    queryList() {
      safetyTaskRecordApi.queryList(this.searchInfo).then(res => {
        this.dataList = res.records;
        this.searchInfo.totalCount = res.totalCount;
      })
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
  }
};
</script>

<style lang="scss" scoped>
</style>